import { render, staticRenderFns } from "./tp-compare.vue?vue&type=template&id=2686bf1a&scoped=true"
import script from "./tp-compare.vue?vue&type=script&lang=js"
export * from "./tp-compare.vue?vue&type=script&lang=js"
import style0 from "./tp-compare.vue?vue&type=style&index=0&id=2686bf1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2686bf1a",
  null
  
)

export default component.exports